// export const baseUrl = "http://192.168.10.74:8000";
export const baseUrl = "https://api.hadoxs.com";
